// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RanaFile } from "./RanaFile";
import {
  RanaFileFromJSON,
  RanaFileFromJSONTyped,
  RanaFileToJSON,
  RanaFileToJSONTyped,
} from "./RanaFile";

/**
 *
 * @export
 * @interface SimulateRainfallOutput
 */
export interface SimulateRainfallOutput {
  /**
   *
   */
  results: RanaFile;
}

/**
 * Check if a given object implements the SimulateRainfallOutput interface.
 */
export function instanceOfSimulateRainfallOutput(value: object): value is SimulateRainfallOutput {
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function SimulateRainfallOutputFromJSON(json: any): SimulateRainfallOutput {
  return SimulateRainfallOutputFromJSONTyped(json, false);
}

export function SimulateRainfallOutputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SimulateRainfallOutput {
  if (json == null) {
    return json;
  }
  return {
    results: RanaFileFromJSON(json["results"]),
  };
}

export function SimulateRainfallOutputToJSON(json: any): SimulateRainfallOutput {
  return SimulateRainfallOutputToJSONTyped(json, false);
}

export function SimulateRainfallOutputToJSONTyped(
  value?: SimulateRainfallOutput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    results: RanaFileToJSON(value["results"]),
  };
}
